import { Cancellation } from 'types';

const getRefundLabel = (cancellation?: Cancellation): string => {
  let cash = false;
  let points = false;

  cancellation?.refund?.totals.forEach(({ amount, currency }) => {
    if (parseFloat(amount) > 0) {
      if (currency === 'AUD') {
        cash = true;
      } else if (currency === 'PTS') {
        points = true;
      }
    }
  });

  if (cash && points) {
    return 'Refund my credit card and Qantas Frequent Flyer account';
  } else if (points) {
    return 'Refund my Qantas Frequent Flyer account';
  } else {
    return 'Refund my credit card';
  }
};

export default getRefundLabel;
